import callApi from '../../util/apiCaller';
import { getPriceCent, getPriceFromCent } from '../../util/price';

import { getVoucherDiscountValue } from '../Voucher/VoucherActions';
import { setIsFetching } from '../App/AppActions';
import { addError } from '../Error/ErrorActions';

export const SET_ORDERS = 'SET_ORDERS';

const ORDERS_FETCH_LIMIT = 1000;


// Requests
export function getOrdersRequest(status = null, onlyFirstItems = false) {
    const recursiveFetch = (limit = ORDERS_FETCH_LIMIT, start = 0, orders = []) => {
        return new Promise((resolve, reject) => {
            return callApi(`orders${status ? `/${status}` : ''}?start=${start}&limit=${limit}`).then(res => {
                if(res.orders && res.orders.length) {
                    return onlyFirstItems ? resolve(res.orders) : resolve(recursiveFetch(limit, start + limit, orders.concat(res.orders)));
                }
                resolve(orders);
            }).catch(err => {
                reject(err);
            });
        });
    };

    return dispatch => {
        dispatch(setIsFetching('orders'));
        return recursiveFetch().then(orders => {
            dispatch(setOrders(orders || []));
            return orders;
        }).catch(err => {
            dispatch(addError(err));
        });
    };
}

export function getOrdersByUserRequest(userId = null) {
    return dispatch => {
        return callApi(`orders/user/${userId || ''}`).then(res => {
            res.orders && dispatch(setOrders(res.orders));
            return res.orders;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function getOrderRequest(orderId) {
    return dispatch => {
        return callApi(`order/${orderId}`).then(res => {
            res.order && dispatch(setOrders([res.order]));
            return res.order;
        }).catch(error => {
            // dispatch(addError(error));
            return null;
        });
    };
}

export function editOrderRequest(order) {
    return dispatch => {
        return callApi('order/edit', 'post', { order }).then(res => {
            res.order && dispatch(getOrderRequest(res.order._id));
            return res.order;
        }).catch(error => {
            // dispatch(addError(error));
            return null;
        });
    };
}

export function createOrderRequest(order) {
    return dispatch => {
        return callApi('order/create', 'post', { order }).then(res => {
            res.order && dispatch(getOrderRequest(res.order._id));
            return res.order;
        }).catch(error => {
            // dispatch(addError(error));
            return null;
        });
    };
}

export function addPaymentRequest(orderId, payment) {
    return dispatch => {
        return callApi('order/payment/add', 'post', { order: { _id: orderId }, payment }).then(res => {
            res.order && dispatch(getOrderRequest(res.order._id));
            return res.order;
        }).catch(error => {
            // dispatch(addError(error));
            return null;
        });
    };
}

export function validPaymentRequest(orderId, paymentId, transaction = null) {
    return dispatch => {
        return callApi('order/payment/valid', 'post', { order: { _id: orderId }, payment: paymentId, transaction }).then(res => {
            res.order && dispatch(getOrderRequest(res.order._id));
            return res.order;
        }).catch(error => {
            // dispatch(addError(error));
            return null;
        });
    };
}

export function sendShippingDataRequest(order) {
    return dispatch => {
        return callApi('order/shipping/send', 'post', { order }).then(res => {
            res.ok && dispatch(getOrderRequest(order._id));
            return res.ok;
        }).catch(error => {
            // dispatch(addError(error));
            return null;
        });
    };
}


// GETTERS
export function getOrders(store, statuses = null) {
    if(statuses && !Array.isArray(statuses)) {
        statuses = [statuses];
    }
    return store.orders.data.filter(order => !statuses || statuses.includes(order.status));
}

export function getOrdersByUser(store, userId, statuses = null) {
    return getOrders(store, statuses).filter(order => !userId || getOrderUserId(order) === userId);
}

export function getOrder(store, orderId) {
    return store.orders.data.find(order => order._id === orderId);
}

export function getOrderUserId(order) {
    return order && order.user && order.user._id ? order.user._id : (order || {}).user;
}

export function getOrderItemsTotal(items) {
    return getPriceFromCent(items.reduce((total, item) => total + getPriceCent(item.unitPriceHT * item.quantity), 0));
}

export function getOrderTotals(items, shippingFee, voucher, tax) {
    const totalItems = getOrderItemsTotal(items);
    const totalShippingFee = shippingFee && shippingFee.amount;
    const totalVoucher = getVoucherDiscountValue(voucher, totalItems, totalShippingFee);
    const subtotalHT = Math.max(0, getPriceFromCent(
        getPriceCent(totalItems)
        + getPriceCent(totalShippingFee || 0)
        - getPriceCent(totalVoucher),
    ));
    const totalTax = tax ? getPriceFromCent(tax.rate * getPriceCent(subtotalHT)) : 0;
    const totalTTC = getPriceFromCent(
        getPriceCent(subtotalHT)
        + getPriceCent(totalTax),
    );
    return {
        items: totalItems,
        shippingFee: totalShippingFee,
        voucher: totalVoucher,
        subtotalHT,
        tax: totalTax,
        totalTTC,
    };
}

export function getOrderStatuses() {
    return ['pendingpayment', 'onpreparation', 'shipped', 'complete', 'archived', 'canceled'];
}

export function getPaymentMethods() {
    return ['creditcard', 'paypal', 'banktransfer'];
}

export function getOrderOption(order, option) {
    return (order && order.options && order.options[option]) || '';
}

export function getOrderStatusColor(status) {
    switch(status) {
        case 'pendingpayment':
            return 'warning';

        case 'onpreparation':
            return 'primary';

        case 'shipped':
            return 'info';

        case 'complete':
            return 'success';

        case 'canceled':
            return 'danger';

        case 'archived':
        default:
            return 'secondary';
    }
}

export function getPaymentStatusColor(status) {
    switch(status) {
        case 'pending':
            return 'warning';

        case 'failed':
            return 'danger';

        case 'complete':
            return 'success';

        default:
            return 'secondary';
    }
}

// Actions
export function setOrders(orders) {
    return {
        type: SET_ORDERS,
        orders,
    };
}
